'use client';

import { useActionState, useMemo, useTransition } from 'react';

export const useResendCodeAction = (
	formAction: (state: any, formData: FormData) => any,
	state: Record<string, string>,
): [string, () => void, boolean] => {
	const [, resendCodeAction, resending] = useActionState(formAction, {});
	const [, startTransition] = useTransition();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const resendKey = useMemo(() => new Date().getTime().toString(), [resending]);

	const submitAction = () => {
		const formData = new FormData();
		formData.set('resend_code', '1');
		for (const key in state) {
			formData.set(key, state[key]);
		}
		startTransition(() => resendCodeAction(formData));
	};

	return [resendKey, submitAction, resending];
};
